<div class="budget-preview-root">
  <ng-template #corporateHeader>
    <header class="document-header">
      <div class="issuer-block">
        @if (budgetPdfVm?.issuer?.logo) {
        <img class="logo" data-pdf-decorative="true" [src]="getSafeImageUrl(budgetPdfVm?.issuer?.logo)"
          (load)="onLogoLoaded($event)" (error)="onLogoError($event)" alt="logo">
        } @else {
        <div class="logo-placeholder">{{ (budgetPdfVm?.issuer?.name || 'CRM').slice(0, 2).toUpperCase() }}</div>
        }
        @if (budgetPdfVm?.issuer?.name) {
        <div class="issuer-name">{{ budgetPdfVm?.issuer?.name }}</div>
        }
      </div>

      <div class="issuer-details">
        @for (item of getVisibleIssuerItems(); track item.label + item.value) {
        <div class="detail-line">
          @if (item.icon) {
          <app-st-icon [name]="item.icon" [filled]="true" [color]="'#4a5561'"></app-st-icon>
          }
          @if (item.label) {
          <strong>{{ item.label }}:</strong>
          }
          <span>{{ item.value }}</span>
        </div>
        }
      </div>
    </header>
  </ng-template>

  @for (pageIndex of pageNumbers; track pageIndex) {
  <section class="page" [class.page-continuation]="pageIndex > 0">
    <ng-container *ngTemplateOutlet="corporateHeader"></ng-container>

    @if (pageIndex === 0) {
    <section class="customer-section">
      @if (budgetPdfVm?.customer?.nameLine) {
      <div class="customer-line customer-name">{{ budgetPdfVm?.customer?.nameLine }}</div>
      }
      @for (address of budgetPdfVm?.customer?.addressLines || []; track address) {
      <div class="customer-line muted">{{ address }}</div>
      }
      @if (budgetPdfVm?.customer?.commercial || budgetPdfVm?.customer?.nif) {
      <div class="customer-separator"></div>
      }
      @if (budgetPdfVm?.customer?.commercial) {
      <div class="customer-line muted"><strong>Comercial:</strong> {{ budgetPdfVm?.customer?.commercial }}</div>
      }
      @if (budgetPdfVm?.customer?.nif) {
      <div class="customer-line muted"><strong>NIF:</strong> {{ budgetPdfVm?.customer?.nif }}</div>
      }
    </section>

    <section class="budget-title-section">
      <h1 class="budget-title">{{ budgetPdfVm?.title }}</h1>
    </section>

    <section class="meta-strip">
      @if (budgetPdfVm?.budgetDate) {
      <div class="meta-item">
        <span>Fecha del presupuesto</span>
        <strong>{{ budgetPdfVm?.budgetDate }}</strong>
      </div>
      }
      @if (budgetPdfVm?.expirationDate) {
      <div class="meta-item">
        <span>Vencimiento</span>
        <strong>{{ budgetPdfVm?.expirationDate }}</strong>
      </div>
      }
      @if (budgetPdfVm?.currencyLabel) {
      <div class="meta-item">
        <span>Moneda</span>
        <strong>{{ budgetPdfVm?.currencyLabel }}</strong>
      </div>
      }
    </section>
    }

    @if (getLinesForPage(pageIndex).length > 0) {
    <section class="services-section">
      <table class="services-table">
        <thead>
          <tr>
            <th class="col-description">Descripción</th>
            <th class="col-quantity">Cantidad</th>
            <th class="col-price">Precio unitario</th>
            @if (!unitary) {
            <th class="col-net-amount">Importe neto</th>
            }
            <th class="col-taxes">Impuestos</th>
            @if (!unitary) {
            <th class="col-amount">Importe</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (line of getLinesForPage(pageIndex); track line.key) {
          <tr [attr.data-fragment-key]="line.key" [attr.data-budget-line-id]="line.value.id">
            <td class="col-description">
              @if (getFragmentDescription(line)) {
              <div class="line-description">{{ getFragmentDescription(line) }}</div>
              }
              @if (!line.continuation && getLineDiscountPercent(line.value) > 0) {
              <div class="line-discount">Desc. {{ getLineDiscountPercent(line.value) | number:'1.0-0' }}%</div>
              }
              @if (getFragmentNote(line)) {
              <div class="line-note">{{ getFragmentNote(line) }}</div>
              }
            </td>
            <td class="col-quantity">@if (!line.continuation) { {{ (line.value.quantity || 0) | number:'1.2-2' }} {{ line.value.unitOfMeasureName || line.value.unitOfMeasure?.name || 'Unidad' }} }</td>
            <td class="col-price">@if (!line.continuation) { {{ (line.value.price || 0) | currency:currencyCode:'symbol':'1.2-4' }} }</td>
            @if (!unitary) {
            <td class="col-net-amount">@if (!line.continuation) { {{ (line.value.netAmount || 0) | currency:currencyCode:'symbol':'1.2-2' }} }</td>
            }
            <td class="col-taxes">@if (!line.continuation) { {{ getTaxPercentage(line.value) }} }</td>
            @if (!unitary) {
            <td class="col-amount">@if (!line.continuation) { {{ (line.value.amount || 0) | currency:currencyCode:'symbol':'1.2-2' }} }</td>
            }
          </tr>
          }
        </tbody>
      </table>
    </section>
    }

    @if (hasSummaryOnPage(pageIndex) && !unitary) {
    <section class="summary-section">
      <table class="summary-table">
        @if (showDiscountBreakdown) {
        <tr>
          <td class="summary-label">Importe base</td>
          <td class="summary-value">{{ baseAmount | currency:currencyCode:'symbol':'1.2-2' }}</td>
        </tr>
        <tr>
          <td class="summary-label">Descuento</td>
          <td class="summary-value">{{ -totalDiscount | currency:currencyCode:'symbol':'1.2-2' }}</td>
        </tr>
        }
        <tr>
          <td class="summary-label">Subtotal</td>
          <td class="summary-value">{{ totalAmount | currency:currencyCode:'symbol':'1.2-2' }}</td>
        </tr>
        <tr>
          <td class="summary-label">Impuesto</td>
          <td class="summary-value">{{ totalIva | currency:currencyCode:'symbol':'1.2-2' }}</td>
        </tr>
        <tr class="total-row">
          <td class="summary-label total-label">Total</td>
          <td class="summary-value total-value">{{ totalWithIva | currency:currencyCode:'symbol':'1.2-2' }}</td>
        </tr>
      </table>
    </section>
    }

    @if (isConditionsPage(pageIndex) && hasConditionsContent(pageIndex)) {
    <section class="conditions-section">
      <div class="conditions-title">Condiciones Generales:</div>
      <div class="conditions-list rich-text-content" [innerHTML]="getConditionsForPage(pageIndex)"></div>
    </section>
    }

    <footer class="footer-section">
      <div class="footer-info">
        <div class="footer-line">
          @for (item of getVisibleFooterItems().slice(0, 2); track item.label + item.value) {
          <span class="footer-item">
            @if (item.icon) {
            <app-st-icon [name]="item.icon" [filled]="true" [color]="'#171717'"></app-st-icon>
            }
            @if (item.label) { <strong>{{ item.label }}:</strong> }
            {{ item.value }}
          </span>
          }
        </div>
        <div class="footer-line">
          @for (item of getVisibleFooterItems().slice(2); track item.label + item.value) {
          <span class="footer-item">
            @if (item.icon) {
            <app-st-icon [name]="item.icon" [filled]="true" [color]="'#171717'"></app-st-icon>
            }
            @if (item.label) { <strong>{{ item.label }}:</strong> }
            {{ item.value }}
          </span>
          }
        </div>
      </div>
      <div class="page-number">Página {{ pageIndex + 1 }} / {{ totalPages }}</div>
    </footer>
  </section>
  }

  <div class="conditions-measurement-host" aria-hidden="true">
    <section class="conditions-measurement-page">
      <ng-container *ngTemplateOutlet="corporateHeader"></ng-container>
      <div #conditionsMeasurementViewport class="conditions-measurement-viewport">
        <section #conditionsMeasurementContent class="conditions-measurement-content">
          <div class="conditions-title">Condiciones Generales:</div>
          <div class="conditions-list conditions-measurement-list rich-text-content" [innerHTML]="conditionsMeasurementHtml"></div>
        </section>
      </div>
      <footer class="footer-section conditions-measurement-footer"></footer>
    </section>
  </div>

  <div class="pdf-ready" *ngIf="renderManifest?.stable"
    [attr.data-expected-line-count]="renderManifest?.expectedLineCount"
    [attr.data-rendered-line-count]="renderManifest?.renderedLineCount"
    [attr.data-page-count]="renderManifest?.pageCount"
    [attr.data-summary-rendered]="renderManifest?.summaryRendered"
    [attr.data-conditions-rendered]="renderManifest?.conditionsRendered"
    [attr.data-stable]="renderManifest?.stable"
    [attr.data-issue-currency]="issueCurrencyEcho"
    [attr.data-issue-rates]="issueRatesEcho" style="display: none"></div>
</div>
